import { create } from 'zustand';
import { getErrorModalMessage } from '../utils/errorMessages';

/**
 * Error Modal Store
 * Manages the state for the ErrorModal component across the app
 * Used to display errors from POST requests and other critical errors
 */
export const useErrorModalStore = create((set) => ({
  // State
  isOpen: false,
  errorMessage: getErrorModalMessage('general_error'),
  errorType: 'general_error', // Used for email template
  actionButton: null, // { title: string, action: function }
  params: {
    postId: null,
    websiteUrl: null,
    userEmail: null,
  },

  // Actions
  openErrorModal: (
    errorMessage = null,
    errorType = 'general_error',
    actionButton = null,
    params = {}
  ) =>
    set({
      isOpen: true,
      errorMessage: errorMessage || getErrorModalMessage(errorType),
      errorType,
      actionButton,
      params: {
        postId: params.postId || null,
        websiteUrl: params.websiteUrl || null,
        userEmail: params.userEmail || null,
      },
    }),

  closeErrorModal: () =>
    set({
      isOpen: false,
      errorMessage: getErrorModalMessage('general_error'),
      errorType: 'general_error',
      actionButton: null,
      params: {
        postId: null,
        websiteUrl: null,
        userEmail: null,
      },
    }),
}));

export default useErrorModalStore;
